var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "entity-type-input" },
    [
      _c(
        "md-button",
        {
          staticClass: "!ml-0 !mr-1",
          class: { "md-secondary": _vm.value == "company" },
          on: {
            click: function($event) {
              _vm.$emit("input", "company")
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("registration.want-to-fly-pro")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-button",
        {
          class: { "md-secondary": _vm.value == "individual" },
          on: {
            click: function($event) {
              _vm.$emit("input", "individual")
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("registration.want-to-fly-private")) +
              "\n    "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80673f74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80673f74","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/EntityTypeInput.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-80673f74","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/EntityTypeInput.vue
// module chunks = 1 2 3